export const getEmptyOtp = (): number[] => [];
